import { IconName, iconNames } from "ts/types/Icon"

export const isIconName = (iconName: string): iconName is IconName => {
  return iconNames.includes(iconName as IconName)
}
